import React, { useEffect, useRef, useState } from 'react';
import { Animated, StyleSheet, TouchableHighlight, View, } from 'react-native';
import Collapsible from 'utils/packages/rnCollapsible';
import Text from 'design-system/Text';
import { rem } from 'design-system/values';
import IconArrow from 'design-system/icons/IconArrow';
import { LineSeparator } from 'design-system/LineSeparator';
import { SettingsItemDescription } from 'design-system/SettingsItem';
import { SettingsItemIcon } from 'design-system/SettingsItemIcon';
import { SettingsSection, } from 'design-system/SettingsSection';
import useColors from 'hooks/useColors';
import Spacer from './Spacer';
export const CollapsableSettingsSection = ({ title, style, children, collapsed, withBottomMargin, enabled = true, forceOpen, renderChildrenCollapsed, icon, renderIcon, description, ...props }) => {
    const [collapser] = useState(new Animated.Value(0));
    const [startCollapse, setStartCollapse] = useState(collapsed);
    const [finishCollapse, setFinishCollapse] = useState(false);
    const isFirstRender = useRef(true);
    useEffect(() => {
        if (collapsed && !isFirstRender.current) {
            setStartCollapse(false);
        }
        isFirstRender.current = false;
    }, [collapsed, forceOpen]);
    useEffect(() => {
        if (startCollapse === finishCollapse) {
            if (startCollapse) {
                Animated.timing(collapser, {
                    toValue: 0,
                    delay: 0,
                    duration: 200,
                    useNativeDriver: true,
                }).start(() => setFinishCollapse(false));
            }
            else {
                Animated.timing(collapser, {
                    toValue: 1,
                    delay: 0,
                    duration: 200,
                    useNativeDriver: true,
                }).start(() => setFinishCollapse(true));
            }
        }
    }, [collapser, finishCollapse, startCollapse]);
    const colors = useColors();
    return (<SettingsSection noMarginTop withBottomMargin={withBottomMargin} style={[styles.collBenefitInside, style]} {...props}>
        <TouchableHighlight underlayColor={colors.background.underlay} activeOpacity={1} disabled={!enabled} onPress={() => setStartCollapse(!startCollapse)}>
          <View style={styles.collBenefitHeader}>
            {!!renderIcon && renderIcon()}
            {icon ? (<View style={styles.iconContainer}>
                <SettingsItemIcon>{icon}</SettingsItemIcon>
              </View>) : null}
            {description ? (<View style={styles.titleAndDescription}>
                <Text Text-16>{title}</Text>
                <SettingsItemDescription>{description}</SettingsItemDescription>
              </View>) : (<Text Text-16 flex>
                {title}
              </Text>)}
            {enabled ? (<>
                <Spacer.W8 />
                <Animated.View style={{
                transform: [
                    {
                        rotate: collapser.interpolate({
                            inputRange: [0, 1],
                            outputRange: ['90deg', '270deg'],
                            extrapolate: 'clamp',
                        }),
                    },
                ],
            }}>
                  <IconArrow />
                </Animated.View>
              </>) : null}
          </View>
        </TouchableHighlight>
        <Collapsible collapsed={startCollapse} renderChildrenCollapsed={renderChildrenCollapsed}>
          <LineSeparator noMargin/>
          {children}
        </Collapsible>
      </SettingsSection>);
};
const styles = StyleSheet.create({
    collBenefitInside: {
        marginHorizontal: rem(16),
        marginTop: rem(16),
    },
    collBenefitHeader: {
        width: '100%',
        paddingVertical: rem(16),
        paddingLeft: rem(16),
        paddingRight: rem(16),
        flexDirection: 'row',
        justifyContent: 'center',
        alignItems: 'center',
    },
    iconContainer: {
        marginRight: rem(16),
    },
    titleAndDescription: {
        flex: 1,
        gap: rem(2),
    },
});
